import React from 'react';
import Asterisk from '@shared/components/Asterisk';
import { OrgOrgUnitSelectors } from '@shared/components/inputs/OrgOrgUnitSelectors';
import { ORG_ORG_UNIT_SELECTOR_MODE } from '@shared/constants/org-org-unit-selector-modes';
import { OrgUnitSelector } from '@shared/components/inputs/OrgUnitSelector';

/**
 * @typedef {object} OrgOrgUnitSelectionProps
 * @property {Array<*>} [organizations]
 * @property {number} [selectedOrgId]
 * @property {Array<*>} [selectedOrgUnitIds]
 * @property {(selections: Object | ((prev: Object) => Object)) => void} [setSelections]
 * @property {boolean} [loading]
 * @property {boolean} [disableOrgUnitSelector]
 * @property {boolean} [displayOnlyUnitSelector]
 * @property {boolean} [hasOrgUnitError]
 */

/**
 * @param {OrgOrgUnitSelectionProps} props
 */
const OrgOrgUnitSelection = props => {
  const {
    organizations = [],
    selectedOrgId,
    selectedOrgUnitIds,
    setSelections,
    displayOnlyUnitSelector,
    disableOrgUnitSelector = false,
    loading,
    hasOrgUnitError = false
  } = props;

  const handleOrgSelection = selectedOrg => {
    setSelections(prevState => ({
      ...prevState,
      orgId: selectedOrg
    }));
    setSelections(prevState => ({ ...prevState, orgUnitIds: [] }));
  };

  const handleUnitSelection = selectedOptions => {
    setSelections(prevState => ({ ...prevState, orgUnitIds: selectedOptions }));
  };

  return (
    <section className='page-section'>
      <div className='section-title bold'>
        <span>
          Unit Selection
          <Asterisk />
        </span>
      </div>
      {displayOnlyUnitSelector ? (
        <div className='option-selector'>
          <OrgUnitSelector
            organizations={organizations.filter(org => org?.Id === selectedOrgId)}
            value={selectedOrgUnitIds}
            onChange={handleUnitSelection}
            loading={loading}
            disabled={disableOrgUnitSelector}
            hasError={hasOrgUnitError}
          />
        </div>
      ) : (
        <OrgOrgUnitSelectors
          sectionClassName='option-selector'
          selectorMode={ORG_ORG_UNIT_SELECTOR_MODE.SINGLE_ORG_MULTIPLE_UNIT_SELECTION}
          organizations={organizations}
          orgSelectorProps={{
            value: selectedOrgId,
            onChange: handleOrgSelection
          }}
          orgUnitSelectorProps={{
            value: selectedOrgUnitIds,
            onChange: handleUnitSelection
          }}
          loading={loading}
        />
      )}
    </section>
  );
};

export default OrgOrgUnitSelection;
